// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"445":"1bfc9850","556":"d64684d8","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"445":"feed47cf25a2e1e3ef1e","556":"ddad6aeaa319464d2a75","678":"4e40392b82cc2e6da616","883":"5255f91c10ca9c49c183"}[chunkId] + ".js";
};